export default window.settings
